import React from 'react';
import './index.scss';
import { FormattedMessage } from 'react-intl';
import {phone, card10,card11, card21, card31 } from '../../assets/cloudinaryUrls.js';

function Buyers()  {
    
        return(
        <>
                 <div className='about-banner'>
        <div className='img-wrapper'>
          <div className='img-text about'>
            <h6><FormattedMessage id="buyer.banner.title" /></h6>
            <h4><FormattedMessage id="buyer.banner.subtitle" /></h4>
          </div>
          <img src={phone} alt='na' className='about-img anim' /> 
        </div>
      </div>
      <div className='services'>
        <div className='serv-content flex-clmn div-prop'>
          <div className='serv-card'>
            <img src={card10} alt='na' className='serv-img anim' /> 
            <div className='serv-block flex-clmn div-prop'>
              <div className='flex-row headline-card'>
                <div className='line line-card'></div>
                <h5><FormattedMessage id="buyer.property_search.title" /></h5>
              </div>
              <p><FormattedMessage id="buyer.property_search.description" /></p>
            </div>
          </div>
          <div className='serv-card'>
            <div className='serv-block flex-clmn div-prop'>
              <div className='flex-row headline-card'>
                <div className='line line-card'></div>
                <h5><FormattedMessage id="buyer.financing.title" /></h5>
              </div>
              <p><FormattedMessage id="buyer.financing.description" /></p>
            </div>
            <img src={card21} alt='na' className='serv-img anim' /> 
          </div>
          <div className='serv-card'>
            <img src={card11} alt='na' className='serv-img anim' /> 
            <div className='serv-block flex-clmn div-prop'>
              <div className='flex-row headline-card'>
                <div className='line line-card'></div>
                <h5><FormattedMessage id="buyer.negotiation.title" /></h5>
              </div>
              <p><FormattedMessage id="buyer.negotiation.description" /></p>
            </div>
          </div>
        </div>
      </div>
      <div className='how-it-works'>
        <div className='headline-block flex-clmn div-prop'>
          <h5><FormattedMessage id="buyer.how_it_works.title" /></h5>
          <div className='line'></div>
          <p><FormattedMessage id="buyer.how_it_works.description" /></p>
        </div>
        <div className='grid-container clmn-block'>
          <div className='square-50 item_1'></div>  
          <div className='p-block item2'>
            <h5><FormattedMessage id="buyer.find_dream_home.title" /></h5>
            <p><FormattedMessage id="buyer.find_dream_home.description" /></p>
          </div>
          <img src={card31} alt='na' className='square-img anim' />
          <img src={card31} alt='na' className='square-img anim' /> 
          <div className='square-120'></div>     
          <div className='square-100'></div> 
          <img src={card31} alt='na' className='square-img item13 anim' /> 
          <img src={card31} alt='na' className='square-img item23 anim' /> 
          <img src={card31} alt='na' className='square-img anim' /> 
          <div className='square-100 right'></div>   
          <div className='square-0 right'></div>   
          <img src={card31} alt='na' className='square-img anim' /> 
          <img src={card31} alt='na' className='square-img anim' /> 
          <img src={card31} alt='na' className='square-img anim' />
          <div className='p-block flex-clmn item44'>
            <h5><FormattedMessage id="buyer.get_best_services.title" /></h5>
            <p><FormattedMessage id="buyer.get_best_services.description" /></p>
          </div>
        </div>
        <div className=' block-two '>
          <div className='grid-container'>   
            <div className='square-180'></div> 
            <img src={card31} alt='na' className='square-img anim' /> 
            <img src={card31} alt='na' className='square-img anim' /> 
            <div className='square-101'></div> 
            <div className='square-102'></div> 
            <div className='p-block flex-clmn item45'>
              <h5><FormattedMessage id="buyer.book_next_visit.title" /></h5>
              <p><FormattedMessage id="buyer.book_next_visit.description" /></p>
            </div>
            <img src={card31} alt='na' className='square-img anim' /> 
            <img src={card31} alt='na' className='square-img anim' /> 
            <div className='square-200'></div>
            <img src={card31} alt='na' className='square-img anim item-last' />  
          </div>
        </div>
      </div>
        </>
        )
    
}

export default Buyers